<template>
  <div class="container">
    <SearchFilter
      :filter-groups="filterGroups"
      :indicator-filter="indicatorFilter"
      @on-confirm-filter="onSearch"
    />
    <div class="poi-card-container">
      <div
        v-if="loading"
        class="loading-card"
      >
        <img src="@/assets/img/icon_rotation_animation@3x.png" />
        <div class="loading-card__text">
          加载中...
        </div>
      </div>
      <div v-else>
        <div
          v-if="poiList.length === 0"
          class="empty-card"
        >
          无筛选结果
        </div>
        <PoiCard
          v-for="item in poiList"
          :key="item.poiId"
          :item="item"
        />
        <div
          v-if="hasMoreData && isLoadingNextPage"
          class="footer"
        >
          加载中...
        </div>
        <div
          v-if="!isLoadingNextPage && !hasMoreData && poiList.length !== 0"
          class="footer"
        >
          没有更多了～
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PoiCard from './components/PoiCard';
import SearchFilter from './components/SearchFilter';
import ServiceLevelApi from '@/api/serviceLevel';
import { INDICATOR_CUST_COMPLAINT_CODES_MAP, SERVICE_LEVEL_CODES_MAP } from '@/constants/serviceLevel';
import Store from '@/store/index';

export default {
  name: 'ServiceLevelPoiList',
  components: {
    PoiCard,
    SearchFilter,
  },
  data() {
    return {
      poiList: [],
      loading: false,
      pageParams: {
        pageSize: 10,
        pageNum: 1,
      },
      filterGroups: [
        {
          tagPartition: 'serviceGrades',
          tagPartitionName: '服务等级',
          tagPartitionText: '服务等级',
          tagKeyMap: SERVICE_LEVEL_CODES_MAP,
          tagKeyList: [],
          selectedTagKeyList: [],
          active: false,
        },
      ],
      indicatorFilter: {
        tagPartition: 'indicatorCodes',
        tagPartitionName: '服务待优化',
        tagPartitionText: '服务待优化',
        tagKeyMap: {
          1: '机柜断电',
          2: '点位偏移',
        },
        custComplaintTagKeyMap: {
          31: '高风险客诉',
          321: '归还客诉-断电',
          322: '归还客诉-异物',
          33: '价格客诉',
          341: '用户差评-价格',
          342: '用户差评-外观',
          343: '用户差评-归还点不好找',
        },
        tagKeyList: [],
        selectedTagKeyList: [],
        active: false,
      },
      isLoadingNextPage: false,
      hasMoreData: true,
      INDICATOR_CUST_COMPLAINT_CODES_MAP,
    };
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    await this.onSearch();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async onSearch() {
      this.pageParams.pageNum = 1;
      this.poiList = [];
      this.hasMoreData = true;
      this.loading = true;
      await this.getPoiList();
      this.loading = false;
    },
    async getPoiList() {
      const serviceGrades = this.filterGroups[0].tagKeyList;
      const indicatorCodes = this.indicatorFilter.tagKeyList;
      const partnerId = Store.getters['partnerModule/id'];
      const params = {
        ...this.pageParams,
        indicatorCodes,
        lastmonthServiceGrades: serviceGrades,
        partnerId,
      };
      const { data, error } = await ServiceLevelApi.getPoiList(params);
      if (!error && data) {
        const list = data.list.map((item) => ({
          ...item,
          serviceGrade: !item.lastmonthServiceGrade ? -1 : item.lastmonthServiceGrade,
          bizareaRank: !item.lastmontBizareaRank ? -1 : item.lastmonthBizareaRank,
          bizareaRankRatio: !item.lastmonthBizareaRankRatio ? '' : item.lastmonthBizareaRankRatio,
        }));
        if (data.total <= this.pageParams.pageSize * (this.pageParams.pageNum - 1) + data.list.length) {
          this.hasMoreData = false;
        }
        this.poiList.push(...list);
      }
    },
    handleScroll() {
      // 检测是否滚动到底部
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 50) {
        // 距离底部 50px 时触发加载下一页
        this.loadNextPage();
      }
    },
    async loadNextPage() {
      if (this.isLoadingNextPage || !this.hasMoreData) {
        return; // 如果正在加载或没有更多数据，则不执行
      }
      this.pageParams.pageNum = this.pageParams.pageNum + 1;
      this.isLoadingNextPage = true;
      await this.getPoiList();
      this.isLoadingNextPage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  min-height:100vh;
  color: #222;
  text-align:left;
  font-family: "PingFang SC";
  .poi-card-container {
    color: #222;
    font-family: PingFang SC;
    padding: 0.86rem 0.24rem 0 0.24rem;
    position: relative;
    .loading-card {
      position: absolute;
      left: 3.39rem;
      top: 40vh;
      img {
        width: 0.72rem;
        display: block;
        margin: 0 auto;
      }
      &__text {
        font-size: 0.28rem;
        margin-top: 0.18rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .empty-card {
      position: absolute;
      left: 2.95rem;
      top: 4.755rem;
      font-size: 0.32rem;
      font-weight: 600;
      margin-top: 0.36rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .footer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666;
      font-size: 0.24rem;
      padding: 0.3rem 0;
    }
  }
}
</style>
